<template>
	<v-card class="mx-auto mb-5">      
		<v-toolbar color="black" dark class="mw-h2">
			{{name}}
			<v-spacer></v-spacer>
			<v-text-field
			v-if="showSearch"
			v-model="search"
			append-icon="mdi-magnify"
			label="Search"
			single-line
			hide-details
			></v-text-field>
		</v-toolbar>
		<v-data-table
		:search="search"
		:headers="headers"
		v-model="selected"
		:items="rows"
		:options="options"
		:show-select="showSelect"
		class="elevation-1"
		>
			
          <template v-slot:item.active="{item}">
            <span class="text-center">
              <v-icon v-if="item.active" color="green">mdi-check-circle</v-icon>
            </span>
          </template> 
          <template v-slot:item.linkTo="{item}">
            <v-btn color="green" link dark :href="editLink + item.id">Edit</v-btn> 
          </template>
          <template v-slot:item.clickEdit="{item}">
            <v-btn color="primary" @click="$emit('click', item)">Edit</v-btn> 
          </template>
          <template v-slot:item.startDate="{item}">
            {{ item.created.toDate() | moment("D/MM/YYYY") }}
          </template>
          <template v-slot:item.endDate="{item}">
            {{ item.created.toDate() | moment("D/MM/YYYY") }}
          </template>
		</v-data-table>
	</v-card>
</template>
<script>	
	export default{
		name: "ListSubpanel",
		props: {
			name: {type: String},
			showSearch: {type: Boolean, default: false },
			showSelect: {type: Boolean, default: false },
			headers: {type: Array },
			rows: {type: Array }, 
			options: {type: Object},
			editLink: {type: String}
		},
		data: () => {
			return {
				search: "",
			}
		},
		created(){
			this.$emit("created");
		}
	}
</script>